import React from 'react';

const UnauthorizedPage = () => {
  const styles = `
    .unauth-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      background: linear-gradient(120deg, #f0f0f0 0%, #d9d9d9 100%);
      margin: 0;
      font-family: 'Segoe UI', Arial, sans-serif;
    }
    .glass-card {
      background: rgba(255, 255, 255, 0.85);
      border-radius: 16px;
      /* Decreased padding for a smaller box */
      padding: 2.8rem 2.1rem;
      box-shadow: 0 8px 32px 0 rgba(150, 150, 150, 0.25);
      backdrop-filter: blur(7px);
      text-align: center;
      /* Decreased min-width for a more compact card */
      min-width: 336px;
      max-width: 95vw;
      /* Thinner border for lighter appearance */
      border: 1.5px solid rgba(200, 200, 200, 0.5);
    }

    .icon-lock {
      margin-bottom: 1.8rem;
      display: flex;
      justify-content: center;
    }
    .icon-lock svg {
      width: 72px;
      height: 72px;
      stroke: #9e9e9e;
      fill: #cfcfcf;
    }
    .unauth-code {
      letter-spacing: 2px;
      font-size: 4rem;
      font-weight: 800;
      color: #7a7a7a;
      text-shadow: none;
      margin-bottom: 0.3rem;
    }
    .unauth-heading {
      font-size: 2.2rem;
      font-weight: 700;
      margin: 0.7rem 0 1.1rem 0;
      color: #5a5a5a;
    }
    .unauth-desc {
      color: #6f6f6f;
      font-size: 1.5rem;
      line-height: 1.7;
      margin-bottom: 0.5rem;
    }
    @media (max-width: 700px) {
      .glass-card {
        min-width: 95vw;
        padding: 2.5rem 0.7rem;
      }
      .icon-lock svg {
        width: 52px;
        height: 52px;
      }
      .unauth-code {
        font-size: 2.6rem;
      }
      .unauth-heading {
        font-size: 1.2rem;
      }
      .unauth-desc {
        font-size: 1rem;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="unauth-container">
        <div className="glass-card">
          <div className="icon-lock">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" fill="none" stroke="#9e9e9e" strokeWidth="2.5">
              <rect x="12" y="25" width="32" height="20" rx="6" fill="#cfcfcf" fillOpacity="1"/>
              <rect x="12" y="25" width="32" height="20" rx="6" stroke="#9e9e9e" strokeWidth="2.5"/>
              <rect x="20" y="21" width="16" height="7" rx="3.5" fill="#b0b0b0" />
              <rect x="20" y="21" width="16" height="7" rx="3.5" stroke="#9e9e9e" strokeWidth="2"/>
              <circle cx="28" cy="35" r="2.5" fill="#b7b7b7"/>
              <rect x="27" y="36.5" width="2" height="6" rx="1" fill="#b7b7b7"/>
            </svg>
          </div>
          <div className="unauth-code">401</div>
          <div className="unauth-heading">Unauthorized</div>
          <div className="unauth-desc">
            You do not have permission to view this page.<br />
          </div>
        </div>
      </div>
    </>
  );
};

export default UnauthorizedPage;
